import { getTrackGap } from "../core/functions";
import React, { MouseEventHandler, useCallback } from "react";
import { SBDTrack } from "./SBDTrack";
import { OccupationsForTrackWithOrder } from "../core/occupations";
import { useChainHighlightHandler } from "../core/useChainHighlighting";
import { useDetailPanelData } from "./useDetailPanelData";

interface SBDTracksProps {
  readonly stageWidth: number;
  readonly occupationsForTrack: OccupationsForTrackWithOrder[];
  readonly zoomLevel: number;
}

export function SBDTracks({
  stageWidth,
  occupationsForTrack,
  zoomLevel,
}: SBDTracksProps): React.JSX.Element {
  const deselectShuntingUnit = useChainHighlightHandler((state) => state.deselectShuntingUnit);
  const clearDetailPanelData = useDetailPanelData((state) => state.clearDetailPanelData);
  const handleClick: MouseEventHandler = useCallback(
    (event) => {
      if (event.target !== event.currentTarget) return;
      deselectShuntingUnit();
      clearDetailPanelData();
    },
    [deselectShuntingUnit, clearDetailPanelData],
  );

  return (
    <div
      className={`relative flex flex-col content-around items-stretch justify-start [&>.track:first-child]:mt-6 [&>.track:last-child]:mb-6`}
      style={{ gap: getTrackGap().toString() }}
      onClick={handleClick}
    >
      {occupationsForTrack.map((occupations) => {
        return (
          <SBDTrack
            key={occupations.track.code}
            stageWidth={stageWidth}
            occupationsForTrack={occupations}
            zoomLevel={zoomLevel}
          />
        );
      })}
    </div>
  );
}
